import React from 'react';
import Link from 'next/link';
import { t } from 'i18next';

const BlogHeader = ({ article }) => {
  return (
    <nav className="my-8 flex">
      <ol role="list" className="flex flex-wrap items-center gap-3">
        <li>
          <div className="flex flex-wrap items-center gap-3 text-zinc-400">
            <Link
              href="/blog"
              className="text-sm font-medium text-zinc-400 hover:text-zinc-600"
              title="Go to Blog"
            >
              Blog
            </Link>{' '}
            /
          </div>
        </li>
        <li>
          <div className="flex flex-wrap items-center gap-3 text-zinc-400">
            <Link
              href={`/blog/category/${article.tagLink}`}
              className="text-sm font-medium text-zinc-400 hover:text-zinc-600"
              title={`View ${t(article.tagLink)} category`}
            >
              {t(article.tagLink)}
            </Link>{' '}
            /
          </div>
        </li>
        <li>
          <div className="flex flex-wrap items-center gap-3 text-zinc-400">
            <p className="text-sm font-medium text-zinc-600">{article.title}</p>
          </div>
        </li>
      </ol>
    </nav>
  );
};

export default BlogHeader;
